import { useContext } from 'react'
import { useMutation, useQuery } from 'react-query'
import { apiPatch, apiPatchFormData, apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getMunicipalitySettings = async (token, municipalityId) => {
  const url = `municipalities/${municipalityId}/settings`
  const data = await apiGet({ url, token })
  return data
}

export default function useMunicipalitySettings({ options }) {
  const { municipality_id } = useContext(UserContext)
  const token = useContext(AuthContext)
  const queryFn = () => getMunicipalitySettings(token, municipality_id)
  const queryKey = 'municipality-settings'
  return useQuery(queryKey, queryFn, { ...options })
}

const updateMunicipalitySettings = async (token, municipalityId, params, hasFile) => {
  const objectName = 'municipality_setting'
  const url = `municipalities/${municipalityId}/settings`

  // Use FormData API if there's a file upload, otherwise use JSON
  if (hasFile) {
    return apiPatchFormData({ url, token, objectName, params })
  } else {
    return apiPatch({ url, token, objectName, params })
  }
}

export function useUpdateMunicipalitySettings({ hasFile = false, options } = {}) {
  const { municipality_id } = useContext(UserContext)
  const token = useContext(AuthContext)

  return useMutation(
    (params) => {
      return updateMunicipalitySettings(token, municipality_id, params, hasFile)
    },
    { ...options }
  )
}
